<div class="orms-spinner spinner-wrapper" [class.absolute-overlay]="absoluteOverlay">
  <mat-spinner [diameter]="diameter" class="spinner"></mat-spinner>
</div>
